export default "__VITE_ASSET__CaHXiJsS__"